import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../Navigation';
import Footer from '../Footer';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page bg-background min-h-screen">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Cookie{' '}
            <span className="bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] bg-clip-text text-transparent">
              Policy
            </span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Learn how we use cookies to enhance your browsing experience
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-1">
            <div className="bg-gradient-to-br from-[#FF56A5]/20 via-[#E852FF]/20 to-[#9F44F2]/20 rounded-2xl p-8">
              <div className="space-y-8 text-gray-300">
                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">1. What Are Cookies</h2>
                  <p>
                    Cookies are small text files that are placed on your computer or mobile device when you
                    visit our website. They are widely used to make websites work more efficiently and provide
                    a better user experience.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">2. How We Use Cookies</h2>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">2.1 Essential Cookies:</h3>
                      <ul className="list-disc ml-6 space-y-2">
                        <li>Authentication and security</li>
                        <li>Session management</li>
                        <li>Load balancing</li>
                        <li>Remember user preferences</li>
                      </ul>
                    </div>
                    
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">2.2 Analytics Cookies:</h3>
                      <ul className="list-disc ml-6 space-y-2">
                        <li>Understanding how visitors use our website</li>
                        <li>Improving our services</li>
                        <li>Measuring the effectiveness of our features</li>
                      </ul>
                    </div>

                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">2.3 Marketing Cookies:</h3>
                      <ul className="list-disc ml-6 space-y-2">
                        <li>Displaying relevant advertisements</li>
                        <li>Tracking marketing campaign performance</li>
                        <li>Preventing the same ad from continuously appearing</li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">3. Third-Party Cookies</h2>
                  <p>
                    Some cookies are placed by third-party services that appear on our pages. We use these
                    services to:
                  </p>
                  <ul className="list-disc ml-6 space-y-2 mt-2">
                    <li>Analyze site traffic (Google Analytics)</li>
                    <li>Process payments securely</li>
                    <li>Provide social media features</li>
                    <li>Deliver targeted advertising</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">4. Managing Cookies</h2>
                  <p>
                    You can control and manage cookies in various ways:
                  </p>
                  <ul className="list-disc ml-6 space-y-2 mt-2">
                    <li>Browser settings to refuse all or some cookies</li>
                    <li>Delete cookies after each session</li>
                    <li>Accept or decline cookies when prompted</li>
                    <li>Use private browsing mode</li>
                  </ul>
                  <p className="mt-4">
                    Please note that blocking some types of cookies may impact your experience of our website
                    and the services we offer.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">5. Cookie Consent</h2>
                  <p>
                    When you first visit our website, we will ask for your consent to set cookies on your
                    device. You can change your cookie preferences at any time through our cookie settings
                    panel.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">6. Updates to This Policy</h2>
                  <p>
                    We may update this Cookie Policy from time to time to reflect changes in our practices or
                    for other operational, legal, or regulatory reasons. We encourage you to periodically
                    review this page for the latest information on our cookie practices.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">7. Contact Us</h2>
                  <p>
                    If you have any questions about our use of cookies, please contact us at:{' '}
                    <a href="mailto:privacy@lifelikeagents.com" className="text-[#E852FF] hover:text-[#FF56A5] transition-colors">
                      privacy@lifelikeagents.com
                    </a>
                  </p>
                </section>

                <div className="mt-8 pt-8 border-t border-white/10">
                  <p className="text-gray-400 text-sm">
                    Last Updated: February 19, 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CookiePolicy; 